import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CardsSection />
        <AppSection />
        <ContactSection />
        <RankingSection />
        <AboutSection />
        <CarouselSection />
        <TopicsSection />
        <FaqSection />
        <UpdatesSection />
        <CommentsSection />
        <FeaturesSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}